import { SearchViewMode } from "../../hooks/types";
var updateFetchDataParams = function (target, src) {
    if (target) {
        Object.assign(target, src);
    }
};
export var getSearchStateApi = function (args, shouldSearch, shouldFetchCounts, initialResultStatus) {
    var utils = {
        searchParamsCurrent: function (prevCriteria) {
            if (shouldSearch) {
                return !shouldSearch(prevCriteria, args.criteria);
            }
            return prevCriteria === args.criteria;
        },
        pageNumberAndSizeCurrent: function (pageNumber, pageSize) {
            return args.pageNumber === pageNumber && args.pageSize === pageSize;
        },
        isSearchCompleted: function (criteria) {
            if (shouldSearch) {
                return !shouldSearch(args.recent.search.criteria, criteria);
            }
            return args.recent.search.criteria === criteria;
        },
        shouldSearchInternal: function () {
            return !utils.searchParamsCurrent(args.recent.search.criteria) &&
                !utils.searchParamsCurrent(args.pending.search.criteria);
        },
        shouldSearch: function () {
            var result = utils.shouldSearchInternal();
            if (result) {
                if (initialResultStatus.searchResult) {
                    utils.setRecentSearchParams(args.criteria);
                    initialResultStatus.searchResult = false;
                    return false;
                }
                initialResultStatus.data[SearchViewMode.MapView] = false;
                initialResultStatus.data[SearchViewMode.ListView] = false;
                initialResultStatus.data[SearchViewMode.GalleryView] = false;
            }
            return result;
        },
        setPendingSearchParams: function (criteria, viewMode, result, pageNumber, pageSize) {
            args.pending.search.criteria = criteria;
            if (viewMode != null && pageNumber != null && pageSize != null) {
                updateFetchDataParams(args.pending.result[viewMode], { result: result, pageNumber: pageNumber, pageSize: pageSize });
            }
        },
        setRecentSearchParams: function (criteria, viewMode, result, pageNumber, pageSize) {
            args.recent.search.criteria = criteria;
            args.pending.search.criteria = undefined;
            if (viewMode != null && pageNumber != null && pageSize != null) {
                updateFetchDataParams(args.recent.result[viewMode], { result: result, pageNumber: pageNumber, pageSize: pageSize });
                updateFetchDataParams(args.pending.result[viewMode], {
                    result: [],
                    pageNumber: undefined,
                    pageSize: undefined,
                });
            }
        },
        fetchCountsParamsCurrent: function (prevCriteria) {
            if (shouldFetchCounts) {
                return !shouldFetchCounts(prevCriteria, args.criteria);
            }
            return prevCriteria === args.criteria;
        },
        shouldFetchCountsInternal: function () {
            return !utils.fetchCountsParamsCurrent(args.recent.counts.criteria) &&
                !utils.fetchCountsParamsCurrent(args.pending.counts.criteria);
        },
        shouldFetchCounts: function () {
            var result = utils.shouldFetchCountsInternal();
            if (result) {
                if (initialResultStatus.counts) {
                    utils.setRecentFetchCountsParams(args.criteria);
                    initialResultStatus.counts = false;
                    return false;
                }
            }
            return result;
        },
        setPendingFetchCountsParams: function (criteria) {
            args.pending.counts.criteria = criteria;
        },
        setRecentFetchCountsParams: function (criteria) {
            args.recent.counts.criteria = criteria;
            args.pending.counts.criteria = undefined;
        },
        fetchDataParamsCurrent: function (result, pageNumber, pageSize) { return args.result === result && args.pageNumber === pageNumber && args.pageSize === pageSize; },
        shouldFetchDataInternal: function (viewMode) {
            var recent = args.recent.result[viewMode];
            var pending = args.pending.result[viewMode];
            return (!utils.fetchDataParamsCurrent(recent === null || recent === void 0 ? void 0 : recent.result, recent === null || recent === void 0 ? void 0 : recent.pageNumber, recent === null || recent === void 0 ? void 0 : recent.pageSize) &&
                !utils.fetchDataParamsCurrent(pending === null || pending === void 0 ? void 0 : pending.result, pending === null || pending === void 0 ? void 0 : pending.pageNumber, pending === null || pending === void 0 ? void 0 : pending.pageSize));
        },
        shouldFetchData: function (viewMode) {
            var result = utils.shouldFetchDataInternal(viewMode);
            if (result) {
                if (initialResultStatus.data[viewMode]) {
                    if (args.result) {
                        utils.setRecentFetchDataParams(viewMode, args.result, args.pageNumber, args.pageSize);
                    }
                    initialResultStatus.data[viewMode] = false;
                    return false;
                }
            }
            return result;
        },
        setPendingFetchDataParams: function (viewMode, result, pageNumber, pageSize) {
            return updateFetchDataParams(args.pending.result[viewMode], {
                result: result,
                pageNumber: pageNumber,
                pageSize: pageSize,
            });
        },
        setRecentFetchDataParams: function (viewMode, result, pageNumber, pageSize) {
            updateFetchDataParams(args.recent.result[viewMode], {
                result: result,
                pageNumber: pageNumber,
                pageSize: pageSize,
            });
            updateFetchDataParams(args.pending.result[viewMode], {
                result: [],
                pageNumber: undefined,
                pageSize: undefined,
            });
        },
    };
    return utils;
};
//# sourceMappingURL=search-state-api.js.map